import React, { ReactNode } from 'react';
import styled from 'styled-components';

import WalletDashboardBody from '#/components/wallet/dashboard/body/WalletDashboardBody';
import { scrollbarStyle } from '#/styleShared';

import WalletHeader from './header/WalletHeader';
import WallletStats from './header/WallletStats';

// const Wrap = styled.div`
//   /* height: 100%; */
//   display: flex;
//   flex-direction: column;
// `;

// const CTAsWrap = styled.div`
//   max-width: 1440px;
//   margin: 16px auto;
//   padding: 0 24px;
// `;

const BeforeBodyWrap = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 16px;
`;

const Scrollable = styled.div<{ $autoHideDesktopScroll: boolean }>`
  flex: 1;

  display: flex;
  flex-direction: column;
  gap: 4px;
  .isMobileStyle & {
    padding: 0 4px;
  }

  /* height: 100%; */
  /*
    Scroll Tradeoffs:

    Intro: It's hard to detect real scroll width across all browsers/OSs.

    On places with Header Stats, we want to hide scrollbars when possible,
    so boxes are aligned with Scrollable table below.

    Instead, on places without Stats boxes, we want better experience
    loading data - so there would be no jumping while loading Trades, etc
    where we expect Scroll in most cases.
   */
  overflow-y: auto;
  /* overflow-y: $ {({ $autoHideDesktopScroll }) =>
    $autoHideDesktopScroll ? 'auto' : 'scroll'}; */
  ${scrollbarStyle}
`;

export default function WalletDashboardContent({
  title,
  children,
  showBalanceActions,
  showStats,
  noBack,
  headerContentRight,
  headerContentMiddle,
  headerBeforeBody,
}: {
  title: ReactNode;
  children: ReactNode;
  headerContentRight?: ReactNode;
  headerContentMiddle?: ReactNode;
  headerBeforeBody?: ReactNode;
  showBalanceActions?: boolean;
  showStats?: boolean;
  noBack?: boolean;
}) {
  return (
    <>
      <WalletHeader
        title={title}
        showBalanceActions={!!showBalanceActions}
        contentRight={headerContentRight}
        noBack={noBack}
      >
        {headerContentMiddle}
      </WalletHeader>
      <Scrollable $autoHideDesktopScroll={!!showStats}>
        {showStats && <WallletStats />}
        {/* {showCTAs && !isMobile && (
          <CTAsWrap>
            <WalletAndMarketsPageCTAs />
          </CTAsWrap>
        )} */}
        {headerBeforeBody && (
          <BeforeBodyWrap>{headerBeforeBody}</BeforeBodyWrap>
        )}
        <WalletDashboardBody>
          <div style={{ padding: 4 }} />
          {children}
        </WalletDashboardBody>
      </Scrollable>
    </>
  );
}
